import { ReactElement } from 'react';
import { OrderReplacement } from '@mapado/seating';
import EventDatePagesHeader from '../components/EventDatePagesHeader';
import useQueryNumberParam from '../useQueryNumberParam';

export default function DemoOrderReplacement(): ReactElement {
  const orderId = useQueryNumberParam('orderId', 805392);
  const eventDateId = useQueryNumberParam('eventDateId', 133018);

  return (
    <>
      <EventDatePagesHeader
        title="Replacement de commande"
        eventDateId={eventDateId}
      />

      <OrderReplacement
        orderId={orderId}
        eventDateId={eventDateId}
        // eslint-disable-next-line no-console
        onDismissSeating={() => console.log('dismiss seating')}
      />
    </>
  );
}
